import React from 'react'
import './submitting-timesheet-popup.css'

const SubmittingTimesheetPopup = (props) => {
    return(
        <div className='submitting-timesheet-popup-wrapper'>
            <div className='submitting-timesheet-modal'>
                <div className='submitting-timesheet-modal__title'>Creating Invoices</div>
                <div className='submitting-timesheet-modal__name'>-{props.currentFamilyName}-</div>
            </div>
        </div>
    )
}
export default SubmittingTimesheetPopup;